import { render, staticRenderFns } from "./UpdateChangesTable.vue?vue&type=template&id=2a79068c&"
import script from "./UpdateChangesTable.vue?vue&type=script&lang=js&"
export * from "./UpdateChangesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports